<template>
  <div class="match-config">
    <h3>匹配场景管理</h3>
    <el-form
      size="mini"
      class="match-config-form"
      ref="matchConfigForm"
      label-width="180px"
      :model="formData"
    >
      <el-collapse
        v-for="(scene, sceneKey) in formData"
        v-model="activeName"
        :key="sceneKey"
      >
        <el-collapse-item :name="scene.name">
          <template slot="title">
            <strong>{{ scene.remark }}</strong>
          </template>

          <!-- <el-card v-if="scene.value.key == 'publish_match_config'">
            <div slot="header">手续费匹配配置</div>
            <el-form-item label="是否开启" prop="needMatch">
              <el-radio-group v-model="ruleForm.list.needMatch">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="匹配人数">
              <el-input v-model="ruleForm.list.matchSize"></el-input>
            </el-form-item>
            <el-form-item label="投递数量">
              <el-input v-model="ruleForm.list.resumeDeliveryLimit"></el-input>
            </el-form-item>
            <el-form-item label="等待时长（分钟）">
              <el-input v-model="ruleForm.list.waitingTime"></el-input>
            </el-form-item>
          </el-card> -->

          <el-card
            v-for="(group, groupKey) in scene.value.list"
            :key="`${scene.remark}${group.label}`"
            class="box-card"
          >
            <div slot="header" class="clearfix">
              <span>{{ group.label }}</span>
            </div>
            <div
              v-for="(item, itemKey) in group.list"
              :key="`${scene.remark}${group.label}${item.label}`"
            >
              <el-form-item
                v-if="item.type"
                :label="item.label"
                :prop="`${sceneKey}.value.list[${groupKey}].list[${itemKey}].value`"
                :rules="Array.from(item.rule || [])"
              >
                <template v-if="item.type == 'radio'">
                  <el-radio-group v-model="item.value">
                    <el-radio
                      v-for="option in item.options"
                      :label="option.value"
                      :key="option.value"
                      >{{ option.label }}</el-radio
                    >
                  </el-radio-group>
                </template>
                <template v-else-if="item.type == 'text'">
                  <el-input type="text" v-model.number="item.value"></el-input>
                </template>
              </el-form-item>
              <div v-else :key="`${scene.remark}${group.label}${item.label}`">
                <el-form-item :label="item.label">
                  <el-form-item
                    v-for="(subItem, subItemKey) in item.list"
                    :label="subItem.label"
                    :key="`${scene.remark}${group.label}${item.label}${subItem.label}`"
                    :prop="`${sceneKey}.value.list[${groupKey}].list[${itemKey}].list[${subItemKey}].value`"
                    :rules="Array.from(subItem.rule || [])"
                  >
                    <template v-if="subItem.type == 'radio'">
                      <el-radio-group v-model="subItem.value">
                        <el-radio
                          v-for="option in subItem.options"
                          :label="option.value"
                          :key="option.value"
                          >{{ option.label }}</el-radio
                        >
                      </el-radio-group>
                    </template>
                    <template v-else-if="subItem.type == 'text'">
                      <el-input
                        type="text"
                        v-model.number="subItem.value"
                      ></el-input>
                    </template>
                  </el-form-item>
                </el-form-item>
              </div>
            </div>
          </el-card>

          <el-form-item label="" style="margin-top: 20px">
            <el-button type="primary" size="medium" @click="submit"
              >保存</el-button
            >
          </el-form-item>
        </el-collapse-item>
      </el-collapse>
    </el-form>
  </div>
</template>
<script>
import api from "../api";

const { match } = api;

export default {
  name: "matchConfig",
  data() {
    return {
      activeName: "",
      formData: {},
      ruleForm: {
        label: "手续费匹配配置",
        groupName: "serviceChargeConfig",
        list: [
          {
            matchSize: "",
            waitingTime: "",
            needMatch: 0,
            resumeDeliveryLimit: "",
          },
        ],
      },
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.getDetail();
  },
  methods: {
    async getDetail() {
      let res = await match.config();
      let { code, data } = res.data;

      if (code == 200) {
        this.formData = data;
      }
    },
    submit() {
      this.$refs["matchConfigForm"].validate((valid) => {
        if (valid) {
          this.update();
        } else {
          return false;
        }
      });
    },
    async update() {
      let obj = this.formData;
      // 合并参数 配置模板用
      // Object.assign(obj.发布后精准匹配.value.list[0], this.ruleForm);
      // console.log(obj, "合并参数---object.assign");
      let {
        data: { code, data },
      } = await match.updateConfig(obj);
      if (code === 200) {
        this.$message.success("更新成功");
        this.getDetail();
      }
    },
  },
};
</script>
<style scoped>
.match-config {
  width: 100%;
}

.el-card {
  width: 640px;
  margin: 20px 0 0 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/match/config.vue